import React from 'react';
import * as S from './style';

const TableColumnsPanel = props => {
  return <S.TableColumnPanel {...props} autoFocusSearchField />;
};

export { TableColumnsPanel };
